import { Component, ViewChild } from '@angular/core';
import { Registration, SelectedWorkerRegistration, WorkerRegistration } from 'src/app/shared/models/registration';
import { alert } from 'devextreme/ui/dialog';
import { WorkerAndToolService } from 'src/app/shared/services/worker-and-tool.service';
import { ToolbarService } from 'src/app/shared/services/toolbar.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { ActivatedRoute, Router } from '@angular/router';
import { HoursOption } from 'src/app/shared/models/hours-option';

import { KindOfWork } from '../../shared/models/kind-of-work';
import { Subject, takeUntil } from 'rxjs';
import { Worker } from 'src/app/shared/models/worker';
import { WorkerCosts } from 'src/app/shared/models/worker-costs';
import { EditorPreparingEvent } from 'devextreme/ui/data_grid';

@Component({
    selector: 'app-registration-workers-select',
    templateUrl: './registration-workers-select.component.html',
    styleUrls: ['./registration-workers-select.component.scss'],
    standalone: false
})
export class RegistrationWorkersSelectComponent {

  @ViewChild(DxDataGridComponent) dataGrid?: DxDataGridComponent;

  registration!:  Registration | undefined;
  selectedRegistrations: SelectedWorkerRegistration[];
  option: HoursOption | undefined;

  forwardSubscription: any;
  backSubscription: any;

  copyWorkerReg: WorkerRegistration[] | undefined;



  costVisible = false;
  cost: WorkerCosts[] = [];
  currentWorker: Worker | undefined;



  workersList: Worker[] = [];

  dailyHoursMap: Map<string, number> = new Map();
  maxRegistrationHours = 0;



  private unsubscribe: Subject<void> = new Subject<void>();


  constructor(
    private service: WorkerAndToolService,
    private toolbar: ToolbarService,
    private route: ActivatedRoute,
    private router: Router) {

      this.selectedRegistrations = [];
    this.copyWorkerReg = [];
    this.cost = [];


    this.getFilteredCostsAll = this.getFilteredCostsAll.bind(this);
    }

    ngOnInit() {
      this.backSubscription = this.toolbar.backClickedEvent.subscribe(()=>this.Back());
      this.forwardSubscription = this.toolbar.forwardClickedEvent.subscribe(() => this.Forward());

      this.service.getHoursOption().then(val => {
        this.option = val;
        this.tryLoadDailyHours();
      });

      this.toolbar.BackVisibleChanged(true);
      this.toolbar.SaveVisibleChanged(false);
      this.toolbar.ForwardVisibleChanged(true);
      this.toolbar.CancelVisibleChanged(false);
      this.toolbar.PlusVisibleChanged(false);
      this.toolbar.EditVisibleChanged(false);
      this.toolbar.DeleteVisibleChanged(false);
      this.toolbar.CopyVisibleChanged(false);
      this.toolbar.MenuVisibleChanged(false);

      let regId = this.route.snapshot.paramMap.get('id');

      if (regId == null) {
        regId = "-1";
      }


      // recupero tutta la lista dei vari workers 
      this.service.getWorkers().then(ws => {
        this.workersList = ws || [];
      });


      this.service.getCurrentWorkerObservable().pipe(takeUntil(this.unsubscribe)).subscribe(val => {
        this.currentWorker = val;
        this.IsCostAllVisible();
      });


      this.service.getcostObservable().pipe(takeUntil(this.unsubscribe)).subscribe((kow) => {
        this.cost = kow ?? [];
      });


      this.service.getTempRegistration(Number(regId)).then((reg)=>
      {
        this.registration = reg;
        if (this.registration)
        {
          this.service.getSelectedWorkerRegistrations(this.registration.workerRegistrations).then((s) => this.selectedRegistrations = s);
          this.tryLoadDailyHours();
        }
      });
      

    }

    ngOnDestroy() {
      this.backSubscription?.unsubscribe();
      this.forwardSubscription?.unsubscribe();
    }

    async Forward()
    {
      // commit di eventuali edit pendenti (es. lookup "Costo" appena selezionata)
      // prima di leggere selectedRegistrations
      await this.dataGrid?.instance.saveEditData();

      if (this.registration)
      {
        // verifico che vi sia almeno una riga inserita
        const currentSelectedRegistrationsWorkers = this.selectedRegistrations.filter(s=>s.selected);
        if (currentSelectedRegistrationsWorkers.length == 0)
        {
          alert("Nessun dipendente selezionato","Errore");
        }
        else if (this.maxRegistrationHours > 0) {
          const overLimitWorkers = currentSelectedRegistrationsWorkers.filter(w => {
            const existing = this.dailyHoursMap.get(w.workerNumber) ?? 0;
            return existing >= this.maxRegistrationHours;
          });
          if (overLimitWorkers.length > 0) {
            const names = overLimitWorkers.map(w => w.workerDescription).join('<br>');
            alert('I seguenti dipendenti hanno già raggiunto il limite massimo di ore giornaliere (' + this.maxRegistrationHours + '):<br>' + names, 'Attenzione');
          }
          else {
            this.proceedForward(currentSelectedRegistrationsWorkers);
          }
        }
        else
        {
          this.proceedForward(currentSelectedRegistrationsWorkers);
        }
      }
      else
      {
        alert("Nessuna registrazione individuata","Errore");
      }
    }

    private proceedForward(currentSelectedRegistrationsWorkers: SelectedWorkerRegistration[]) {
      if (!this.registration) return;

          if (this.costVisible && this.option?.cost == 2 && currentSelectedRegistrationsWorkers.filter(f => !f.cost).length > 0) {
            alert("Alcuni dipendenti non hanno tipo di costo indicato", "Errore");
            return;
          }

          //this.registration.allSelectedPhases

          const NoPhases = this.registration.noPhase;

          if ((this.registration.allSelectedPhases && this.registration.allSelectedPhases.length > 0) || NoPhases) {

            if (NoPhases) {

              this.registration?.workerRegistrations.forEach(wreg => {
                this.copyWorkerReg?.push(wreg);
              });


              // ripulisco worker registration
              this.registration.workerRegistrations = [];

              for (let i = 0; i < currentSelectedRegistrationsWorkers.length; i++)
              {

                let ore = 8;
                let tool = null;

                this.registration.workerRegistrations.push(
                  {
                    workerNumber: currentSelectedRegistrationsWorkers[i].workerNumber,
                    workerDescription: currentSelectedRegistrationsWorkers[i].workerDescription,
                    oreLavorate: ore,
                    toolCode: tool,
                    phaseCode: this.registration.cantiere!,//"000",
                    phaseDescription: this.registration.descrizioneCantiere,
                    keyIdentification: this.registration.cantiere! + "" + currentSelectedRegistrationsWorkers[i].workerNumber,//"000" + "" + currentSelectedRegistrationsWorkers[i].workerNumber,
                    cost: currentSelectedRegistrationsWorkers[i].cost
                  });

              }
            }
            else {

              // mi mantengo solo le registrazioni multiple con le fasi in comune
              this.registration.allSelectedPhases!.forEach(selPhase => {
                this.registration?.workerRegistrations.forEach(wreg => {
                  if (wreg.phaseCode == selPhase.constructionPhaseCode) {
                    this.copyWorkerReg?.push(wreg);
                  }
                })
              });

              // ripulisco worker registration
              this.registration.workerRegistrations = [];

              for (let i = 0; i < currentSelectedRegistrationsWorkers.length; i++)
              {
                for (let phaseIndex = 0; phaseIndex < this.registration.allSelectedPhases!.length; phaseIndex++) {


                  // dati di Defualt
                  let ore = this.registration.allSelectedPhases![phaseIndex].hoursTime;
                  let tool = null;

                  // dati in caso ci fossero delle registrazioni in comune
                  this.copyWorkerReg?.forEach(x => {
                    if (this.registration?.allSelectedPhases
                      && x.phaseCode == this.registration?.allSelectedPhases[phaseIndex].constructionPhaseCode
                      && x.workerNumber == currentSelectedRegistrationsWorkers[i].workerNumber) {
                      ore = x.oreLavorate;
                      tool = x.toolCode;
                    }

                  });

                  this.registration.workerRegistrations.push(
                    {
                      workerNumber: currentSelectedRegistrationsWorkers[i].workerNumber,
                      workerDescription: currentSelectedRegistrationsWorkers[i].workerDescription,
                      oreLavorate: ore,
                      toolCode: tool,
                      phaseCode: this.registration.allSelectedPhases![phaseIndex].constructionPhaseCode,
                      phaseDescription: this.registration.allSelectedPhases![phaseIndex].constructionPhaseDescription,
                      keyIdentification: this.registration.allSelectedPhases![phaseIndex].constructionPhaseCode + "" + currentSelectedRegistrationsWorkers[i].workerNumber,

                      cost: currentSelectedRegistrationsWorkers[i].cost

                    });
                }
              }

            }

          }
          else {
            // DEFAULT OPERATIONS

            // elimino le righe delle registrazioni non presenti tra quelle selezionate

            this.registration.workerRegistrations = this.registration?.workerRegistrations.filter(r => currentSelectedRegistrationsWorkers.some(s => s.workerNumber == r.workerNumber)) ?? [];

            // Aggiungo le righe delle registrazioni su quelle selezionate,
            // se esiste già non faccio nulla altrimenti aggiungo le ore
            const selectedMissingRegistrations = currentSelectedRegistrationsWorkers.filter(s => !this.registration?.workerRegistrations.some(f => f.workerNumber == s.workerNumber));


            // se si è dimenticato la chiave gliela rigenero qui dentro
            this.registration.workerRegistrations.forEach(x => {
              x.keyIdentification = x.workerNumber;
            })


            // Salvo la registrazione
              for (let i = 0; i < selectedMissingRegistrations.length; i++) {
                this.registration.workerRegistrations.push(
                  {
                    workerNumber: selectedMissingRegistrations[i].workerNumber,
                    workerDescription: selectedMissingRegistrations[i].workerDescription,
                    oreLavorate: this.registration.oreLavorate ?? 8,
                    toolCode: null,
                    phaseCode: null,
                    phaseDescription: null,
                    keyIdentification: selectedMissingRegistrations[i].workerNumber,




                    cost: selectedMissingRegistrations[i].cost




                  }
                );

            }
          }

          // Passo alla pagina successiva
          this.service.editTempRegistration(this.registration, this.registration.id ?? 0).then((regId)=> this.router.navigate(['/registration-worker-hour',{id: regId}]))
    }

    Back()
    {
      if (this.option?.multiplePhases) {
        this.router.navigate(['/registration-phase', { id: this.registration?.id }]);
      }
      else {
        this.router.navigate(['/registration', { id: this.registration?.id }]);
      }
    }



  //
  getFilteredCostsAll(options: { data: SelectedWorkerRegistration; }) {

    const workerNumber = options?.data?.workerNumber;
    const worker = this.workersList.find(w => w.workerNumber === workerNumber);
    const workerPosition = worker?.position ?? null;

    return {
      store: this.cost,
      filter: workerPosition ? ['workerPosition', '=', workerPosition] : null,
      //filter: "workerPosition = " + options.data.workerNumber
    };
  }


  private tryLoadDailyHours() {
    if (!this.registration || !this.option || this.dailyHoursMap.size > 0) return;
    if (this.option.maxRegistrationHours && this.option.maxRegistrationHours > 0) {
      this.maxRegistrationHours = this.option.maxRegistrationHours;
      const date = this.registration.dataRegistrazioneString;
      const excludeId = this.registration.id && this.registration.id > 0 ? this.registration.id : undefined;
      Promise.all([
        this.service.getWorkerDailyHoursForDate(date),
        this.service.getUnsyncedWorkerHoursForDate(date, excludeId)
      ]).then(([syncedHours, unsyncedHours]) => {
        syncedHours.forEach(h => this.dailyHoursMap.set(h.workerNumber, h.totalHours));
        unsyncedHours.forEach((hours, workerNumber) => {
          const current = this.dailyHoursMap.get(workerNumber) ?? 0;
          this.dailyHoursMap.set(workerNumber, current + hours);
        });
      });
    }
  }

  onEditorPreparing(e: EditorPreparingEvent) {
    if (e.dataField === 'selected' && e.parentType === 'dataRow') {
      const workerNumber = (e.row?.data as SelectedWorkerRegistration)?.workerNumber;
      if (workerNumber && this.maxRegistrationHours > 0) {
        const existing = this.dailyHoursMap.get(workerNumber) ?? 0;
        if (existing >= this.maxRegistrationHours) {
          e.editorOptions.disabled = true;
        }
      }
    }
  }

  private IsCostAllVisible() {
    if (this.option) {

      this.costVisible = this.option.cost != 0 &&
        ((this.option.multiplePhases ?? false) || (this.option.costPerWorkerRow ?? false));
    }
    else {
      this.costVisible = false;
    }
  }

}
